<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import pkg from './package.json'
import { useInitDefaultStore } from '@/stores/defaultStore'
import 'virtual:svg-icons-register'

import.meta.client && useInitDefaultStore()
console.info('%cversion: ' + pkg.version, 'color:red;font-size:20px')
</script>
